/* Zalify popup close-icon fallback
   Zalify's stock close icon is hosted on the Cloudinary account "flashmail-testing",
   which now answers 401 for every asset -> the image renders as a broken-image glyph.
   The popup lives inside a shadow root, so page-level CSS cannot reach it; this script
   reaches into the shadow root and swaps the broken image for an inline SVG cross.
   Safe to delete at any time: if Zalify fixes their CDN, nothing here will trigger. */
(function () {
  var ICON =
    "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%232b2b2b' stroke-width='2.2' stroke-linecap='round'%3E%3Cpath d='M6 6l12 12M18 6L6 18'/%3E%3C/svg%3E";
  var BAD = "flashmail-testing";

  function fixImg(img) {
    if (img.dataset.zalifyCloseFixed === "1") return;
    var badSrc = !!img.getAttribute("src") && img.getAttribute("src").indexOf(BAD) > -1;
    var broken = img.complete && img.naturalWidth === 0;
    if (!badSrc && !broken) return;
    img.dataset.zalifyCloseFixed = "1";
    img.removeAttribute("srcset");
    img.src = ICON;
    img.style.objectFit = "contain";
    img.style.display = "inline-block";
  }

  function scan(root) {
    var list = root.querySelectorAll(
      '[data-zalify-action="close"] img, img[src*="' + BAD + '"]'
    );
    for (var i = 0; i < list.length; i++) fixImg(list[i]);
  }

  function scanAll() {
    var hosts = document.querySelectorAll("[data-zalify-popup-host]");
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].shadowRoot) {
        try { scan(hosts[i].shadowRoot); } catch (e) {}
      }
    }
    try { scan(document); } catch (e) {} // fallback if Zalify drops the shadow DOM
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scanAll();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scanAll);
  }
  window.addEventListener("load", scanAll);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
  scanAll();
})();
